import React, { Component } from 'react';
import Typical from 'react-typical';
import Skill from './SkillComponent';
import About from './AboutComponent';
import Project from './ProjectComponent';
import Contact from './ContactComponent';

class Home extends Component {
  render() {
    return (
      <React.Fragment>
        <div className=' container'>
          <div className=' circle'>
            {' '}
            <img
              class='home-page1'
              width='172px'
              height='172px'
              src='./assets/images/img.jpg'
              alt='logo'
            />
          </div>
          <div className='row '>
            <span className='Vertical-line'></span>
          </div>
          <div className='col'>
            <hr className='line-hr ' />
          </div>
          <div className='row '>
            <div className='col-12 home-page'>
              <p>
                {' '}
                <b>Hello, I'm Tewabe!</b> <br />
                <h4>I am a Software Developer and </h4>
                <Typical
                  className='typical-tt'
                  loop={Infinity}
                  wrapper='p'
                  steps={[
                    'optimist 🍀',
                    1000,
                    'motivated 🏃‍♂️',
                    1000,
                    'disciplined 🤵‍♂️',
                    1000,
                    'sociable 😁',
                    1000,
                    'team player 👫',
                    1000,
                    'bookworm 📚',
                    1000,
                    'trilingual ✋🏽',
                    1000,
                    'goal-oriented 🎯',
                    1000,
                    'resilient 💪',
                    1000,
                    'creative 🎨',
                    1000,
                    'focused 🔍',
                    1000,
                    'dream chaser 🌟',
                    1000,
                    'problem solver 🧩',
                    1000,
                    'adaptable 🌱',
                    1000,
                    'leader 🏆',
                    1000,
                    'visionary 🌅',
                    1000,
                    'hard worker 🛠️',
                    1000,
                  ]}
                />
              </p>
            </div>
          </div>
          <div className='row '>
            <div className='col'>
              <hr className='line-hr1 ' />
            </div>
          </div>
          <div className='row '>
            <span className='Vertical-line1'></span>
          </div>
          <div className='row button-row grid-container'>
            <div className='col-sm-2 grid-item'>
              <a className='button-row-grid' href="#about">
                <About />
              </a>
            </div>
            <div className='col-sm-2 grid-item'>
              <a className='button-row-grid' href="#skill">
                <Skill />
              </a>
            </div>
            <div className='col-sm-3 grid-item'>
              <a className='button-row-grid' href="#project">
                <Project />
              </a>
            </div>
            <div className=' col-sm-3 grid-item' >
              <a className='button-row-grid' href="#contact">
                <Contact />
              </a>
            </div>
            <div className=' col-sm-2 grid-item'>
              <a
                className='button-row-grid'
                href='https://ttewabe.github.io/html-j'
                target='_blank' rel="noreferrer"
              >
                Resume
              </a>
            </div>
          </div>
          <div className='row'>
            <div className=' col-12 footer'>
              <a
                className='btn'
                href='https://github.com/ttewabe'
                target='_blank' rel="noreferrer"
              >
                <p>🎅 DECEMBER 2018</p>
              </a>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default Home;
